import React from 'react';

import { LoadingIndicator } from '@lf/ui-primitives';
import SearchBox from '../../components/SearchBox';
import VideoList from '../../components/VideoList';
import YouTubeVideoCard from './YouTubeVideoCard';

const SearchView = ({
  searchTerm,
  onChange,
  onSubmit,
  onClear,
  isLoading,
  videos,
  hasSearched,
  savedVideoIds,
  onVideoSelect,
  onChannelSelect,
  onSaveToggle,
}) => (
  <>
    <SearchBox value={searchTerm} onChange={onChange} onSubmit={onSubmit} onClear={onClear} />
    {isLoading ? (
      <div className="mt-12">
        <LoadingIndicator />
      </div>
    ) : videos.length > 0 ? (
      <VideoList>
        {videos.map((video) => (
          <YouTubeVideoCard
            key={video.id?.videoId}
            video={video}
            onSelect={onVideoSelect}
            onChannelSelect={onChannelSelect}
            isSaved={savedVideoIds.has(video.id?.videoId)}
            onSaveToggle={onSaveToggle}
          />
        ))}
      </VideoList>
    ) : (
      hasSearched && (
        <div className="text-center text-gray-600 mt-12">
          No videos found. Try searching for something else.
        </div>
      )
    )}
  </>
);

export default SearchView;
